/*
 * @Author: wuzhen wz0309@163.com
 * @Date: 2023-11-22 09:07:34
 * @LastEditors: LILy0401 2686739469@qq.com
 * @LastEditTime: 2024-08-28 16:06:08
 * @FilePath: \eiiplat_front\src\api\console.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

export function getUserInfo() {
  return request({
    url: "/pt/tenant/getMyTenantInfo",
    method: "post"
  })
}

export function getRecord() {
  return request({
    url: "/jz/visit/distinctList",
    method: "get"
  })
}

export function addRecord(params) {
  return request({
    url: "/jz/visit/save",
    method: "post",
    data: {
      sysCode: params.appId || params.sysCode,
      sysName: params.dict_label || params.sysName,
      url: params.url
    }
  })
}

export function listProduct(params) {
  return request({
    url: "/jz/visit/list-product",
    method: "get",
    params
  })
}


export function articleList(params) {
  return request({
    url: "/jz/co-article/list",
    method: "get",
    params
  })
}


export function detailArticle(params) {
  return request({
    url: "/jz/co-article//detail",
    method: "get",
    params
  });
}

// 看板办公用品
export function getOfficeList(params) {
  return request({
    url: "/pt/pt-office-application/list",
    method: "get",
    params
  })
}

// 申请企业审批
export function saveOrUpdate (data) {
  return request({
    url:"/pt/pt-enterprise-approval/saveOrUpdate",
    method:"post",
    data:data
  })
}

// 查询企业审批
export function fingList(params) {
  return request({
    url:"/pt/pt-enterprise-approval/fingList",
    method:"get",
    params
  })
}

// 查看审批详情
export function getApprovalType (params) {
  return request ({
    url:"/pt/pt-enterprise-approval" + params,
    method:"get"
  })
}

// 查看审核状态信息
export function getApprovalMess() {
  return request ({
    url:"/pt/pt-enterprise-approval/getApprovalMess",
    method:'get'
  })
}
//查看token是否有效 ​/api​/auth​/verifyToken
export function getveriftToken() {
  return request ({
    url:"/auth/verifyToken",
    method:'get'
  })
}
// 咨询和询价
export function consultlist(params) {
  return request({
    url: '/pt/consult/page',
    method: 'get',
    params
  })
}
// 试用
export function getDemandTrialList(params) {
  return request({
    url: '/app-community/demandTrial/getDemandTrialList',
    method: 'get',
    params
  })
}
// 我的订单
export function getDemandOrderList(params) {
  return request({
    url: '/app-community/demandOrder/getDemandOrderList',
    method: 'get',
    params
  })
}
// 删除订单
export function demandOrderremove(params) {
  return request({
    url: '/app-community/demandOrder/remove/'+params.id,
    method: 'post'
  })
}
export function consultdetail(params) {
  return request({
    url: '/pt/consult/getDetails',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/console.js